"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.embedPlainTextForMock = exports.buildOrgFacingBase = exports.MOCK_ORGANIZATION_NAME = exports.pickForLocale = void 0;
const email_theme_tokens_1 = require("../../helpers/email-theme-tokens");
const email_templates_1 = require("../../internationalization/locales/email-templates");
const pickForLocale = (record, locale) => record[locale.toUpperCase()] ?? record.EN;
exports.pickForLocale = pickForLocale;
exports.MOCK_ORGANIZATION_NAME = "Bright Futures Foundation";
const buildOrgFacingBase = (locale, subject) => ({
    labels: (0, email_templates_1.getEmailLabels)(locale),
    theme: (0, email_theme_tokens_1.getOrgFacingEmailTheme)(),
    currentYear: new Date().getFullYear(),
    lang: locale,
    subject,
    orgName: exports.MOCK_ORGANIZATION_NAME,
    isPreview: false,
});
exports.buildOrgFacingBase = buildOrgFacingBase;
const embedPlainTextForMock = (plainText) => {
    const escaped = plainText
        .replace(/\r\n/g, "\n")
        .replace(/&/g, "&amp;")
        .replace(/</g, "&lt;")
        .replace(/>/g, "&gt;")
        .replace(/"/g, "&quot;")
        .replace(/'/g, "&#39;");
    return `<pre style="margin:0;font-family:inherit;font-size:inherit;line-height:1.5;white-space:pre-wrap;">${escaped}</pre>`;
};
exports.embedPlainTextForMock = embedPlainTextForMock;
